import React from 'react';

const Button = ({ text, className, link, func }) => {
  return (
    <a href={link} className={`px-10 py-3.5 w-full text-center rounded-md shadow-md block sm:w-auto duration-300 cursor-pointer text-white bg-red-600 hover:bg-red-500 active:bg-red-700 ${className}`} onClick={func}>
      {text}
    </a>
  );
};

export default Button;